import { render } from "./RecieversGroupComponent.vue?vue&type=template&id=a4f77f60&scoped=true"
import script from "./RecieversGroupComponent.vue?vue&type=script&lang=js"
export * from "./RecieversGroupComponent.vue?vue&type=script&lang=js"

import "./RecieversGroupComponent.vue?vue&type=style&index=0&id=a4f77f60&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f77f60"]])

export default __exports__